// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/account.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { AccountAddress } from "./account_address_pb.js";
import { file_crm_v1_account_address } from "./account_address_pb.js";
import type { Contact } from "./contact_pb.js";
import { file_crm_v1_contact } from "./contact_pb.js";
import type { AccountIndividualDetails } from "./account_individual_details_pb.js";
import { file_crm_v1_account_individual_details } from "./account_individual_details_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/account.proto.
 */
export const file_crm_v1_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types, file_crm_v1_account_address, file_crm_v1_contact, file_crm_v1_account_individual_details]);

/**
 * Account message definition
 *
 * @generated from message crm.v1.Account
 */
export type Account = Message<"crm.v1.Account"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: crm.v1.AccountType account_type = 3;
   */
  accountType: AccountType;

  /**
   * @generated from field: bool is_customer = 4;
   */
  isCustomer: boolean;

  /**
   * @generated from field: bool is_supplier = 5;
   */
  isSupplier: boolean;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: string phone = 7;
   */
  phone: string;

  /**
   * @generated from field: string website = 8;
   */
  website: string;

  /**
   * @generated from field: string notes = 9;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 10;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.ID linked_organization_id = 11;
   */
  linkedOrganizationId?: ID;

  /**
   * @generated from field: bool is_carrier = 12;
   */
  isCarrier: boolean;

  /**
   * @generated from field: repeated string account_manager_ids = 13;
   */
  accountManagerIds: string[];

  /**
   * @generated from field: types.ID default_purchase_payment_term_id = 14;
   */
  defaultPurchasePaymentTermId?: ID;

  /**
   * @generated from field: types.ID default_sales_payment_term_id = 15;
   */
  defaultSalesPaymentTermId?: ID;

  /**
   * @generated from field: string scac = 16;
   */
  scac: string;

  /**
   * @generated from field: string mc_number = 17;
   */
  mcNumber: string;

  /**
   * @generated from field: string dot_number = 18;
   */
  dotNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp insurance_expiration = 19;
   */
  insuranceExpiration?: Timestamp;

  /**
   * @generated from field: string payment_type_preference = 20;
   */
  paymentTypePreference: string;

  /**
   * @generated from field: string payment_schedule_preference = 21;
   */
  paymentSchedulePreference: string;

  /**
   * @generated from field: bool w9_on_file = 22;
   */
  w9OnFile: boolean;

  /**
   * @generated from field: types.Base base = 23;
   */
  base?: Base;

  /**
   * @generated from field: repeated crm.v1.AccountAddress addresses = 24;
   */
  addresses: AccountAddress[];

  /**
   * @generated from field: repeated crm.v1.Contact contacts = 25;
   */
  contacts: Contact[];

  /**
   * @generated from field: crm.v1.AccountIndividualDetails individual_details = 26;
   */
  individualDetails?: AccountIndividualDetails;
};

/**
 * Describes the message crm.v1.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema: GenMessage<Account> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 0);

/**
 * Request/Response messages for Account queries
 *
 * @generated from message crm.v1.GetAccountRequest
 */
export type GetAccountRequest = Message<"crm.v1.GetAccountRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;

  /**
   * @generated from field: bool include_contacts = 3;
   */
  includeContacts: boolean;

  /**
   * @generated from field: bool include_addresses = 4;
   */
  includeAddresses: boolean;

  /**
   * @generated from field: bool include_individual_details = 5;
   */
  includeIndividualDetails: boolean;
};

/**
 * Describes the message crm.v1.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema: GenMessage<GetAccountRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 1);

/**
 * @generated from message crm.v1.GetAccountResponse
 */
export type GetAccountResponse = Message<"crm.v1.GetAccountResponse"> & {
  /**
   * @generated from field: crm.v1.Account account = 1;
   */
  account?: Account;
};

/**
 * Describes the message crm.v1.GetAccountResponse.
 * Use `create(GetAccountResponseSchema)` to create a new message.
 */
export const GetAccountResponseSchema: GenMessage<GetAccountResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 2);

/**
 * @generated from message crm.v1.ListAccountsRequest
 */
export type ListAccountsRequest = Message<"crm.v1.ListAccountsRequest"> & {
  /**
   * @generated from field: crm.v1.ListAccountsFilter filter = 1;
   */
  filter?: ListAccountsFilter;

  /**
   * @generated from field: repeated crm.v1.AccountSortOption sorting = 2;
   */
  sorting: AccountSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message crm.v1.ListAccountsRequest.
 * Use `create(ListAccountsRequestSchema)` to create a new message.
 */
export const ListAccountsRequestSchema: GenMessage<ListAccountsRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 3);

/**
 * @generated from message crm.v1.ListAccountsFilter
 */
export type ListAccountsFilter = Message<"crm.v1.ListAccountsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: crm.v1.AccountType account_type = 3;
   */
  accountType: AccountType;

  /**
   * @generated from field: google.protobuf.StringValue email = 6;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 7;
   */
  phone?: string;

  /**
   * @generated from field: google.protobuf.StringValue website = 8;
   */
  website?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue linked_organization_id = 11;
   */
  linkedOrganizationId?: string;

  /**
   * @generated from field: google.protobuf.StringValue default_purchase_payment_term_id = 14;
   */
  defaultPurchasePaymentTermId?: string;

  /**
   * @generated from field: google.protobuf.StringValue default_sales_payment_term_id = 15;
   */
  defaultSalesPaymentTermId?: string;

  /**
   * @generated from field: google.protobuf.StringValue scac = 16;
   */
  scac?: string;

  /**
   * @generated from field: google.protobuf.StringValue mc_number = 17;
   */
  mcNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue dot_number = 18;
   */
  dotNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue payment_type_preference = 20;
   */
  paymentTypePreference?: string;

  /**
   * @generated from field: google.protobuf.StringValue payment_schedule_preference = 21;
   */
  paymentSchedulePreference?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 23;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 24;
   */
  organizationId?: ID;

  /**
   * @generated from field: google.protobuf.BoolValue is_customer = 4;
   */
  isCustomer?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue is_supplier = 5;
   */
  isSupplier?: boolean;

  /**
   * @generated from field: bool preload_contacts = 30;
   */
  preloadContacts: boolean;

  /**
   * @generated from field: bool preload_addresses = 31;
   */
  preloadAddresses: boolean;

  /**
   * @generated from field: bool account_types = 32;
   */
  accountTypes: boolean;

  /**
   * @generated from field: bool preload_individual_details = 33;
   */
  preloadIndividualDetails: boolean;
};

/**
 * Describes the message crm.v1.ListAccountsFilter.
 * Use `create(ListAccountsFilterSchema)` to create a new message.
 */
export const ListAccountsFilterSchema: GenMessage<ListAccountsFilter> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 4);

/**
 * @generated from message crm.v1.ListAccountsResponse
 */
export type ListAccountsResponse = Message<"crm.v1.ListAccountsResponse"> & {
  /**
   * @generated from field: repeated crm.v1.Account accounts = 1;
   */
  accounts: Account[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message crm.v1.ListAccountsResponse.
 * Use `create(ListAccountsResponseSchema)` to create a new message.
 */
export const ListAccountsResponseSchema: GenMessage<ListAccountsResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 5);

/**
 * Command messages
 *
 * @generated from message crm.v1.CreateAccountRequest
 */
export type CreateAccountRequest = Message<"crm.v1.CreateAccountRequest"> & {
  /**
   * @generated from field: crm.v1.AccountInput input = 1;
   */
  input?: AccountInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.CreateAccountRequest.
 * Use `create(CreateAccountRequestSchema)` to create a new message.
 */
export const CreateAccountRequestSchema: GenMessage<CreateAccountRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 6);

/**
 * @generated from message crm.v1.CreateAccountResponse
 */
export type CreateAccountResponse = Message<"crm.v1.CreateAccountResponse"> & {
  /**
   * @generated from field: crm.v1.Account account = 1;
   */
  account?: Account;
};

/**
 * Describes the message crm.v1.CreateAccountResponse.
 * Use `create(CreateAccountResponseSchema)` to create a new message.
 */
export const CreateAccountResponseSchema: GenMessage<CreateAccountResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 7);

/**
 * @generated from message crm.v1.UpdateAccountRequest
 */
export type UpdateAccountRequest = Message<"crm.v1.UpdateAccountRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: crm.v1.AccountUpdateInput input = 2;
   */
  input?: AccountUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.UpdateAccountRequest.
 * Use `create(UpdateAccountRequestSchema)` to create a new message.
 */
export const UpdateAccountRequestSchema: GenMessage<UpdateAccountRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 8);

/**
 * @generated from message crm.v1.UpdateAccountResponse
 */
export type UpdateAccountResponse = Message<"crm.v1.UpdateAccountResponse"> & {
  /**
   * @generated from field: crm.v1.Account account = 1;
   */
  account?: Account;
};

/**
 * Describes the message crm.v1.UpdateAccountResponse.
 * Use `create(UpdateAccountResponseSchema)` to create a new message.
 */
export const UpdateAccountResponseSchema: GenMessage<UpdateAccountResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 9);

/**
 * @generated from message crm.v1.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"crm.v1.DeleteAccountRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 10);

/**
 * Input messages
 *
 * @generated from message crm.v1.AccountInput
 */
export type AccountInput = Message<"crm.v1.AccountInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: crm.v1.AccountType account_type = 3;
   */
  accountType: AccountType;

  /**
   * @generated from field: bool is_customer = 4;
   */
  isCustomer: boolean;

  /**
   * @generated from field: bool is_supplier = 5;
   */
  isSupplier: boolean;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: string phone = 7;
   */
  phone: string;

  /**
   * @generated from field: string website = 8;
   */
  website: string;

  /**
   * @generated from field: string notes = 9;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 10;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.ID linked_organization_id = 11;
   */
  linkedOrganizationId?: ID;

  /**
   * @generated from field: bool is_carrier = 12;
   */
  isCarrier: boolean;

  /**
   * @generated from field: repeated string account_manager_ids = 13;
   */
  accountManagerIds: string[];

  /**
   * @generated from field: types.ID default_purchase_payment_term_id = 14;
   */
  defaultPurchasePaymentTermId?: ID;

  /**
   * @generated from field: types.ID default_sales_payment_term_id = 15;
   */
  defaultSalesPaymentTermId?: ID;

  /**
   * @generated from field: string scac = 16;
   */
  scac: string;

  /**
   * @generated from field: string mc_number = 17;
   */
  mcNumber: string;

  /**
   * @generated from field: string dot_number = 18;
   */
  dotNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp insurance_expiration = 19;
   */
  insuranceExpiration?: Timestamp;

  /**
   * @generated from field: string payment_type_preference = 20;
   */
  paymentTypePreference: string;

  /**
   * @generated from field: string payment_schedule_preference = 21;
   */
  paymentSchedulePreference: string;

  /**
   * @generated from field: bool w9_on_file = 22;
   */
  w9OnFile: boolean;
};

/**
 * Describes the message crm.v1.AccountInput.
 * Use `create(AccountInputSchema)` to create a new message.
 */
export const AccountInputSchema: GenMessage<AccountInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 11);

/**
 * @generated from message crm.v1.AccountUpdateInput
 */
export type AccountUpdateInput = Message<"crm.v1.AccountUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue name = 1;
   */
  name?: string;

  /**
   * @generated from field: crm.v1.AccountType account_type = 2;
   */
  accountType: AccountType;

  /**
   * @generated from field: google.protobuf.BoolValue is_customer = 3;
   */
  isCustomer?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue is_supplier = 4;
   */
  isSupplier?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue email = 5;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 6;
   */
  phone?: string;

  /**
   * @generated from field: google.protobuf.StringValue website = 7;
   */
  website?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 8;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 9;
   */
  customAttributes?: string;

  /**
   * @generated from field: types.ID linked_organization_id = 10;
   */
  linkedOrganizationId?: ID;

  /**
   * @generated from field: google.protobuf.BoolValue is_carrier = 11;
   */
  isCarrier?: boolean;

  /**
   * @generated from field: repeated string account_manager_ids = 12;
   */
  accountManagerIds: string[];

  /**
   * @generated from field: types.ID default_purchase_payment_term_id = 13;
   */
  defaultPurchasePaymentTermId?: ID;

  /**
   * @generated from field: types.ID default_sales_payment_term_id = 14;
   */
  defaultSalesPaymentTermId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue scac = 15;
   */
  scac?: string;

  /**
   * @generated from field: google.protobuf.StringValue mc_number = 16;
   */
  mcNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue dot_number = 17;
   */
  dotNumber?: string;

  /**
   * @generated from field: google.protobuf.Timestamp insurance_expiration = 18;
   */
  insuranceExpiration?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue payment_type_preference = 19;
   */
  paymentTypePreference?: string;

  /**
   * @generated from field: google.protobuf.StringValue payment_schedule_preference = 20;
   */
  paymentSchedulePreference?: string;

  /**
   * @generated from field: google.protobuf.BoolValue w9_on_file = 21;
   */
  w9OnFile?: boolean;
};

/**
 * Describes the message crm.v1.AccountUpdateInput.
 * Use `create(AccountUpdateInputSchema)` to create a new message.
 */
export const AccountUpdateInputSchema: GenMessage<AccountUpdateInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 12);

/**
 * GetAccountsByCustomAttributeRequest - custom query request
 *
 * @generated from message crm.v1.GetAccountsByCustomAttributeRequest
 */
export type GetAccountsByCustomAttributeRequest = Message<"crm.v1.GetAccountsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetAccountsByCustomAttributeRequest.
 * Use `create(GetAccountsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetAccountsByCustomAttributeRequestSchema: GenMessage<GetAccountsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 13);

/**
 * GetAccountsByCustomAttributeResponse - custom query response
 *
 * @generated from message crm.v1.GetAccountsByCustomAttributeResponse
 */
export type GetAccountsByCustomAttributeResponse = Message<"crm.v1.GetAccountsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated crm.v1.Account result = 1;
   */
  result: Account[];
};

/**
 * Describes the message crm.v1.GetAccountsByCustomAttributeResponse.
 * Use `create(GetAccountsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetAccountsByCustomAttributeResponseSchema: GenMessage<GetAccountsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 14);

/**
 * CheckAccountSearchPermissionsRequest - custom query request
 *
 * @generated from message crm.v1.CheckAccountSearchPermissionsRequest
 */
export type CheckAccountSearchPermissionsRequest = Message<"crm.v1.CheckAccountSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.CheckAccountSearchPermissionsRequest.
 * Use `create(CheckAccountSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckAccountSearchPermissionsRequestSchema: GenMessage<CheckAccountSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 15);

/**
 * CheckAccountSearchPermissionsResponse - custom query response
 *
 * @generated from message crm.v1.CheckAccountSearchPermissionsResponse
 */
export type CheckAccountSearchPermissionsResponse = Message<"crm.v1.CheckAccountSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string result = 1;
   */
  result: string[];
};

/**
 * Describes the message crm.v1.CheckAccountSearchPermissionsResponse.
 * Use `create(CheckAccountSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckAccountSearchPermissionsResponseSchema: GenMessage<CheckAccountSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account, 16);

/**
 * AccountType enum
 *
 * @generated from enum crm.v1.AccountType
 */
export enum AccountType {
  /**
   * @generated from enum value: ACCOUNT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_TYPE_COMMERCIAL = 1;
   */
  COMMERCIAL = 1,

  /**
   * @generated from enum value: ACCOUNT_TYPE_INDIVIDUAL = 2;
   */
  INDIVIDUAL = 2,
}

/**
 * Describes the enum crm.v1.AccountType.
 */
export const AccountTypeSchema: GenEnum<AccountType> = /*@__PURE__*/
  enumDesc(file_crm_v1_account, 0);

/**
 * @generated from enum crm.v1.AccountSortOption
 */
export enum AccountSortOption {
  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_NAME_ASC = 1;
   */
  NAME_ASC = 1,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_NAME_DESC = 2;
   */
  NAME_DESC = 2,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_ACCOUNT_TYPE_ASC = 3;
   */
  ACCOUNT_TYPE_ASC = 3,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_ACCOUNT_TYPE_DESC = 4;
   */
  ACCOUNT_TYPE_DESC = 4,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_EMAIL_ASC = 5;
   */
  EMAIL_ASC = 5,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_EMAIL_DESC = 6;
   */
  EMAIL_DESC = 6,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_CREATED_AT_ASC = 7;
   */
  CREATED_AT_ASC = 7,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_CREATED_AT_DESC = 8;
   */
  CREATED_AT_DESC = 8,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_UPDATED_AT_ASC = 9;
   */
  UPDATED_AT_ASC = 9,

  /**
   * @generated from enum value: ACCOUNT_SORT_OPTION_UPDATED_AT_DESC = 10;
   */
  UPDATED_AT_DESC = 10,
}

/**
 * Describes the enum crm.v1.AccountSortOption.
 */
export const AccountSortOptionSchema: GenEnum<AccountSortOption> = /*@__PURE__*/
  enumDesc(file_crm_v1_account, 1);

/**
 * Services
 *
 * @generated from service crm.v1.AccountQueriesService
 */
export const AccountQueriesService: GenService<{
  /**
   * @generated from rpc crm.v1.AccountQueriesService.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof GetAccountRequestSchema;
    output: typeof GetAccountResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountQueriesService.ListAccounts
   */
  listAccounts: {
    methodKind: "unary";
    input: typeof ListAccountsRequestSchema;
    output: typeof ListAccountsResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountQueriesService.GetAccountsByCustomAttribute
   */
  getAccountsByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetAccountsByCustomAttributeRequestSchema;
    output: typeof GetAccountsByCustomAttributeResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckAccountSearchPermissionsRequestSchema;
    output: typeof CheckAccountSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account, 0);

/**
 * @generated from service crm.v1.AccountCommandsService
 */
export const AccountCommandsService: GenService<{
  /**
   * @generated from rpc crm.v1.AccountCommandsService.CreateAccount
   */
  createAccount: {
    methodKind: "unary";
    input: typeof CreateAccountRequestSchema;
    output: typeof CreateAccountResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountCommandsService.UpdateAccount
   */
  updateAccount: {
    methodKind: "unary";
    input: typeof UpdateAccountRequestSchema;
    output: typeof UpdateAccountResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountCommandsService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account, 1);

